// extracted by mini-css-extract-plugin
module.exports = {"validationTips":"_3Uq387s","suggestions":"_zFmoYBc","suggestion":"_3SzJsd4"};